import React, { useRef } from 'react';
import { Icons, SVG } from '../../../../components/atoms/SVG';
import { Tooltip, TooltipPlacement } from '../../../../components/atoms/Tooltip';
import { GlobalDocumentIds } from '../../../../types/GlobalDocumentIds';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { CloseSubPanel } from '../../MainNavigationTypes';

type PreviousPanelButton = {
  panelName?: string;
  closeSubPanel: CloseSubPanel;
  panelLevel: number;
};

export function PreviousPanelButton({ panelName, closeSubPanel, panelLevel }: PreviousPanelButton) {
  const { t } = useSonTranslation('MainNavigation');
  const buttonRef = useRef<HTMLButtonElement>(null);
  const buttonName = t('subPanels.backPanelButton', { panelName: panelName ?? '' });

  const button = (
    <button
      ref={buttonRef}
      type="button"
      className="main-navigation__sub-panel-button"
      onClick={(event: React.MouseEvent) => {
        event.preventDefault();
        event.stopPropagation();
        closeSubPanel(panelLevel);
      }}
      // first panel references main panel
      aria-controls={
        panelLevel - 1 === 0
          ? GlobalDocumentIds.mainNavigationPanel
          : `${GlobalDocumentIds.mainNavigationSubPanel}${panelLevel - 1}`
      }
      aria-expanded="false" // as button disappears onclick, true state is not needed here
      title={buttonName}
    >
      <span className="invisible">{buttonName}</span>
      <span className="main-navigation__sub-panel-button-icon">
        <SVG svgSpriteId={Icons.ARROW_LEFT} />
      </span>
    </button>
  );

  // Tooltip is only rendered once the panel name is available (panel data is loaded),
  // otherwise the tooltip would be created from an empty panel name and never update.
  if (!panelName) {
    return button;
  }

  return (
    <Tooltip attachTo={buttonRef} hideTooltipFromScreenReader placement={TooltipPlacement.TOP} hideOnClick>
      {button}
    </Tooltip>
  );
}
